"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import Link from "next/link";
import { useRouter, useSearchParams } from "next/navigation";
import { Tooltip } from "react-tooltip";
import { usePrefetchWaveData } from "@/hooks/usePrefetchWaveData";
import { useWaveData } from "@/hooks/useWaveData";
import useIsMobileDevice from "@/hooks/isMobileDevice";
import { ApiWaveType } from "@/generated/models/ObjectSerializer";
import WavePicture from "@/components/waves/WavePicture";
import { useMyStream } from "@/contexts/wave/MyStreamContext";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { getWaveHomeRoute, getWaveRoute } from "@/helpers/navigation.helpers";
interface BrainContentPinnedWaveProps {
  readonly waveId: string;
  readonly active: boolean;
  readonly onMouseEnter: (waveId: string) => void;
  readonly onMouseLeave: () => void;
  readonly onRemove: (waveId: string) => void;
}
const BrainContentPinnedWave: React.FC<BrainContentPinnedWaveProps> = t0 => {
  const $ = _c(58);
  const {
    waveId,
    active,
    onMouseEnter,
    onMouseLeave,
    onRemove
  } = t0;
  const router = useRouter();
  const searchParams = useSearchParams();
  const prefetchWaveData = usePrefetchWaveData();
  const {
    registerWave
  } = useMyStream();
  const {
    isApp
  } = useDeviceInfo();
  let t1;
  if ($[0] !== onRemove || $[1] !== waveId) {
    t1 = () => onRemove(waveId);
    $[0] = onRemove;
    $[1] = waveId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1 || $[4] !== waveId) {
    t2 = {
      waveId,
      onWaveNotFound: t1
    };
    $[3] = t1;
    $[4] = waveId;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    data: wave
  } = useWaveData(t2);
  const isMobile = useIsMobileDevice();
  const isDropWave = wave && wave.wave.type !== ApiWaveType.Chat;
  let t3;
  if ($[6] !== isApp || $[7] !== searchParams || $[8] !== wave?.chat?.scope?.group?.is_direct_message) {
    t3 = waveId_0 => {
      const currentWaveId = searchParams?.get("wave") ?? undefined;
      const isDirectMessage = wave?.chat?.scope?.group?.is_direct_message ?? false;
      if (currentWaveId === waveId_0) {
        return getWaveHomeRoute({
          isDirectMessage,
          isApp
        });
      }
      return getWaveRoute({
        waveId: waveId_0,
        isDirectMessage,
        isApp
      });
    };
    $[6] = isApp;
    $[7] = searchParams;
    $[8] = wave?.chat?.scope?.group?.is_direct_message;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const getHref = t3;
  let t4;
  if ($[10] !== getHref || $[11] !== onMouseLeave || $[12] !== router || $[13] !== waveId) {
    t4 = e => {
      e.preventDefault();
      onMouseLeave();
      router.push(getHref(waveId));
    };
    $[10] = getHref;
    $[11] = onMouseLeave;
    $[12] = router;
    $[13] = waveId;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const onLinkClick = t4;
  let t5;
  if ($[15] !== onMouseEnter || $[16] !== prefetchWaveData || $[17] !== registerWave || $[18] !== searchParams || $[19] !== waveId) {
    t5 = () => {
      onMouseEnter(waveId);
      const currentWaveId_0 = searchParams?.get("wave") ?? undefined;
      if (waveId === currentWaveId_0) {
        return;
      }
      registerWave(waveId);
      prefetchWaveData(waveId);
    };
    $[15] = onMouseEnter;
    $[16] = prefetchWaveData;
    $[17] = registerWave;
    $[18] = searchParams;
    $[19] = waveId;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  const onHover = t5;
  let t6;
  if ($[21] !== onRemove || $[22] !== waveId) {
    t6 = e_0 => {
      e_0.preventDefault();
      e_0.stopPropagation();
      onRemove(waveId);
    };
    $[21] = onRemove;
    $[22] = waveId;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  const onRemoveClick = t6;
  const t7 = `tw-relative tw-group tw-transition-all tw-duration-300 ${!active ? "tw-opacity-70" : ""}`;
  let t8;
  if ($[24] !== getHref || $[25] !== waveId) {
    t8 = getHref(waveId);
    $[24] = getHref;
    $[25] = waveId;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  const t9 = `wave-tooltip-${waveId}`;
  const t10 = `
            tw-relative tw-h-6 tw-px-1.5 tw-rounded-lg tw-flex tw-items-center tw-gap-1
            tw-cursor-pointer tw-transition-all tw-duration-300
            ${active ? "tw-bg-primary-500/15 tw-ring-primary-400/30 tw-ring-1 tw-ring-inset" : "tw-bg-iron-800 tw-ring-iron-700 tw-ring-1 tw-ring-inset"}
          `;
  let t11;
  if ($[27] !== wave) {
    t11 = <div className="tw-relative tw-size-3.5 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-overflow-hidden tw-bg-iron-900">{wave ? <WavePicture name={wave.name} picture={wave.picture} contributors={wave.contributors_overview.map(_temp)} /> : <div className="tw-w-full tw-h-full tw-bg-iron-800" />}</div>;
    $[27] = wave;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  const t12 = `tw-relative tw-text-[11px] tw-font-medium tw-whitespace-nowrap ${active ? "tw-text-primary-400" : "tw-text-iron-200"}`;
  const t13 = wave?.name;
  let t14;
  if ($[29] !== t12 || $[30] !== t13) {
    t14 = <span className={t12}>{t13}</span>;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== isDropWave) {
    t15 = isDropWave && <svg className="tw-size-3 tw-flex-shrink-0 tw-text-[#E8D48A]" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M400 0L176 0c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8L24 64C10.7 64 0 74.7 0 88c0 92.6 33.5 157 78.5 200.7c44.3 43.1 98.3 64.8 138.1 75.8c23.4 6.5 39.4 26 39.4 45.6c0 20.9-17 37.9-37.9 37.9L192 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-26.1 0C337 448 320 431 320 410.1c0-19.6 15.9-39.2 39.4-45.6c39.9-11 93.9-32.7 138.2-75.8C542.5 245 576 180.6 576 88c0-13.3-10.7-24-24-24L446.4 64c.3-5.2 .5-10.4 .7-15.8C448.1 21.8 426.5 0 400 0zM48.9 112l84.4 0c9.1 90.1 29.2 150.3 51.9 190.6c-24.9-11-50.8-26.5-73.2-48.3c-32-31.1-58-76-63-142.3zM464.1 254.3c-22.4 21.8-48.3 37.3-73.2 48.3c22.7-40.3 42.8-100.5 51.9-190.6l84.4 0c-5.1 66.3-31.1 111.2-63 142.3z" /></svg>;
    $[32] = isDropWave;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <svg className="tw-size-4 tw-flex-shrink-0" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M17 7L7 17M7 7L17 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== onRemoveClick) {
    t17 = <button type="button" onClick={onRemoveClick} aria-label="Remove wave" className="tw-relative -tw-mr-0.5 tw-border-0 tw-bg-transparent tw-p-0.5 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-iron-400 tw-cursor-pointer tw-opacity-100  desktop-hover:hover:tw-text-red tw-transition-all tw-duration-300">{t16}</button>;
    $[35] = onRemoveClick;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t10 || $[38] !== t11 || $[39] !== t14 || $[40] !== t15 || $[41] !== t17 || $[42] !== t9) {
    t18 = <div data-tooltip-id={t9} className={t10}>{t11}{t14}{t15}{t17}</div>;
    $[37] = t10;
    $[38] = t11;
    $[39] = t14;
    $[40] = t15;
    $[41] = t17;
    $[42] = t9;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== isMobile || $[45] !== wave?.name || $[46] !== waveId) {
    t19 = !isMobile && <Tooltip id={`wave-tooltip-${waveId}`} place="top" style={{
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    }}><span className="tw-text-xs">{wave?.name ?? ""}</span></Tooltip>;
    $[44] = isMobile;
    $[45] = wave?.name;
    $[46] = waveId;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] !== onLinkClick || $[49] !== t18 || $[50] !== t19 || $[51] !== t8) {
    t20 = <Link href={t8} onClick={onLinkClick} className="tw-flex tw-items-center tw-no-underline tw-group">{t18}{t19}</Link>;
    $[48] = onLinkClick;
    $[49] = t18;
    $[50] = t19;
    $[51] = t8;
    $[52] = t20;
  } else {
    t20 = $[52];
  }
  let t21;
  if ($[53] !== onHover || $[54] !== onMouseLeave || $[55] !== t20 || $[56] !== t7) {
    t21 = <div className={t7} onMouseEnter={onHover} onMouseLeave={onMouseLeave}>{t20}</div>;
    $[53] = onHover;
    $[54] = onMouseLeave;
    $[55] = t20;
    $[56] = t7;
    $[57] = t21;
  } else {
    t21 = $[57];
  }
  return t21;
};
export default BrainContentPinnedWave;
function _temp(c) {
  return {
    pfp: c.contributor_pfp
  };
}